import { IPreloadSystem } from 'src/app/apis/preload-system.service';

export let PRELOAD_SYSTEM: IPreloadSystem | undefined;

export function SET_PRELOAD_SYSTEM(data: IPreloadSystem) {
  if (PRELOAD_SYSTEM) {
    throw new Error('Preload system already set!');
  }

  PRELOAD_SYSTEM = data;
}
